module.exports = __webpack_public_path__ + "img/KAWASAKI.82bddc5.jpg";